import styled from '@emotion/styled'

export const HouseOverviewContainer = styled.div`
  grid-area: header;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 ${({ theme }) => theme.spacing(-2)};
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.palette.glass[500]};
  label: HouseOverviewContainer;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin: 0;
    background-color: ${({ theme }) => theme.palette.common.white};
    padding: 0;
    align-items: flex-start;
  }
`

export const HouseBasicInformation = styled.div`
  flex: 2;
`

export const VendorLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  padding: 4px;
  border-radius: var(--border-radius-card-large);
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.stone[50]};

  & img {
    object-fit: contain;
    object-position: center;
  }
  label: VendorLogoContainer;
`
